import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../api/auth.service';
import { Router } from '@angular/router';
import { User } from 'src/app/entity/user';
import { SnackbarService } from '../../snackbar/service/snackbar.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  loginForm: FormGroup;
  error: string;
  hide = true;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private snackbarService: SnackbarService,
    private translate: TranslateService
  ) {
    this.loginForm = fb.group({
      Email: ['', [Validators.required]],
      Password: ['', [Validators.required]],
    });
  }

  login() {
    const user: User = { ...this.loginForm.value };
    this.authService.login(user).subscribe(
      (response) => {
        localStorage.setItem('token', response.token);

        if (this.authService.isAuthenticated) {
          const redirectUrl = this.authService.redirectUrl;
          this.router.navigate([redirectUrl]);
        }
      },
      (error) => {
        this.error = error;
        this.snackbarService.open('login.snackbar.error', 5, 'failed');
        console.log('' + error);
      }
    );
  }

  forgotPassword() {
    var email = "info@roombuildingpartner.de";
    var subject = "OutlinesMR - " + this.translate.instant(
      'login.forgotPassword'
    );
    var emailBody = this.translate.instant(
      'login.forgotPasswordEmailText'
    );
    window.location.href = "mailto:"+email+"?subject="+subject+"&body="+emailBody;
  }
}
